import React, { FC, useState } from "react";
import { RouterParamType } from "@/model/navModel";
import { TableBox } from "./TableBox";

export const MaterialInfo: FC<RouterParamType> = (detailsInfo) => {

    return (
        <>
            <TableBox {...detailsInfo} />
        </>
    )
}